/**
 * 입력/문구 제한 (07_FRONTEND_UX.md 기반 요약)
 */
export const LIMITS = {
  post: {
    titleMin: 2,
    titleMax: 200,
    contentMin: 10,
    contentMax: 50_000,
  },
  comment: {
    min: 1,
    max: 1000,
  },
  diary: {
    memoMin: 10,
    memoMax: 2000,
  },
  profile: {
    nicknameMin: 2,
    nicknameMax: 10,
    bioMax: 200,
  },
  upload: {
    imageMaxMB: 5,
    allowedMime: ['image/jpeg', 'image/png', 'image/webp'],
  },
} as const;

export const INITIAL_VIRTUAL_CASH = 10_000_000; // 1천만원
export const COMMISSION_RATE = 0.0005; // 0.05%
